import { getAudioCapabilities, getVideoCapabilities } from '@mi-front/core';
import debugFn from 'debug';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

const debug = debugFn('usePostHogMediaTechSync');

/**
 * Syncs media tech capabilities (audio/video) to PostHog as person properties
 * so they are available for segmentation without emitting events.
 */
export function usePostHogMediaTechSync() {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    try {
      const properties = {
        media_tech_audio: getAudioCapabilities(),
        media_tech_video: getVideoCapabilities(),
      };

      debug('syncing media tech', properties);

      posthog.people.set(properties);
    } catch {
      // ignore analytics failures
    }
  }, [posthog]);
}
